/* eslint-disable consistent-return */
/* eslint-disable react/button-has-type */
import { IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { FunctionComponent, useEffect } from 'react';
import Skeleton from '../../image/webp_SkeletonCons.webp';
import ApplShop from '../../image/ApplShop_2.png';
import AndroidShop from '../../image/AndroidShop_2.png';
import HuaweiShop from '../../image/HuaweiShop_2.png';
import { HandleAutoShopView } from '../../utils/utils';
import { MyButton } from '../UI/MyButton';

interface Props {
  onClickEvent: () => void;
  link: string;
  open: boolean;
}

export const PutchaseDivModal: FunctionComponent<Props> = ({
  onClickEvent,
  link,
  open,
}) => {
  const prodolgitokupku = () => {
    window.location.replace(link);
  };

  useEffect(() => {
    if (!open) return; // Работаем только когда модалка открыта

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        if (link === '') {
          onClickEvent();
        } else {
          // window.location.replace(link);
        }
      }
    };

    // Слушаем событие изменения видимости
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Очистка при размонтировании или закрытии модалки
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [open]);

  if (!open) {
    return null;
  }

  const getSizePictureFona = () => {
    let widtn = window.innerWidth;
    let heghh = window.innerHeight;

    if (widtn > 1270) {
      widtn = 1270;
    }
    if (heghh > 1624) {
      heghh = 1624;
    }
    widtn = (heghh * 1270) / 1624;
    return `${widtn}px ${heghh}px`;
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: '#1D2228',
        backgroundImage: `url(${Skeleton})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: `${getSizePictureFona()}`,
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Stack
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack
          width="90%"
          alignItems="end"
          justifyContent="end"
          paddingTop="44px"
          spacing={3}
        >
          <IconButton size="medium" onClick={onClickEvent}>
            <CloseIcon
              sx={{
                color: '#FFFFFF',
              }}
              fontSize="medium"
            />
          </IconButton>
        </Stack>
        <Stack width="100%" alignItems="center" spacing={3}>
          <Typography
            fontWeight={700}
            width="232px"
            fontFamily="Comfortaa"
            lineHeight="32px"
            fontSize="26px"
            letterSpacing="0.26px"
            textAlign="center"
            color="#FFFFFF"
            component="text"
          >
            Скачайте приложение
          </Typography>
          <Typography
            fontWeight={400}
            width="232px"
            fontFamily="Roboto"
            lineHeight="20px"
            fontSize="16px"
            letterSpacing="0.3px"
            textAlign="center"
            color="#FFFFFF"
            component="text"
          >
            Похоже у вас <span style={{ fontWeight: 700 }}>не установлено</span>{' '}
            приложение УчиМед
          </Typography>
          <Typography
            fontWeight={400}
            width="232px"
            fontFamily="Roboto"
            lineHeight="20px"
            fontSize="16px"
            letterSpacing="0.3px"
            textAlign="center"
            color="#FFFFFF"
            component="text"
          >
            <span style={{ fontWeight: 700 }}>
              Скачайте приложение и вернитесь
            </span>{' '}
            на эту страницу
          </Typography>
        </Stack>

        <Stack
          width="100%"
          alignItems="center"
          paddingBottom="44px"
          spacing={2}
        >
          <Typography
            fontWeight={400}
            width="232px"
            fontFamily="Roboto"
            lineHeight="20px"
            fontSize="14px"
            letterSpacing="0.3px"
            textAlign="center"
            color="#FFFFFF"
            component="text"
          >
            Все магазины:
          </Typography>
          <Stack direction="row" spacing={2}>
            <Stack onClick={() => HandleAutoShopView(0)}>
              <img alt="" width="77.33px" height="50px" src={ApplShop} />
            </Stack>
            <Stack onClick={() => HandleAutoShopView(1)}>
              <img alt="" width="77.33px" height="50px" src={AndroidShop} />
            </Stack>
            <Stack onClick={() => HandleAutoShopView(2)}>
              <img alt="" width="77.33px" height="50px" src={HuaweiShop} />
            </Stack>
          </Stack>

          <Stack
            sx={{
              filter: 'drop-shadow(0 0 30px #3478F6)',
            }}
          >
            <Stack>
              <MyButton
                text={
                  <Typography
                    width="178px"
                    fontWeight={500}
                    fontFamily="Roboto"
                    lineHeight="100%"
                    fontSize="14px"
                    letterSpacing="0.3px"
                    textAlign="center"
                    color="#FFFFFF"
                    component="text"
                  >
                    Продолжить покупку
                  </Typography>
                }
                background="#3478F6"
                color="#FFFFFF"
                borderRadius="20px"
                width="252px"
                height="72px"
                onClick={prodolgitokupku}
              />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
};
